import {Trans} from '@lingui/macro';
import React from 'react';

import {CollapsedItemKeyPrefixesEnum} from '../../../models/api/localPreferencesModel';
import {useSettingsInfoBox, UseSettingsInfoBoxProps} from '../../helpers/settingsInfoBox';

/*
 * Consts.
 */

const settingsInfoBoxProps: UseSettingsInfoBoxProps = {
  settingsExpandedKey: CollapsedItemKeyPrefixesEnum.SETTINGS_PREVIEWERS,
  title: <Trans id="settings-previewers-infobox-title">Link previews</Trans>,
  body: (
    <Trans id="settings-previewers-infobox-body">
      <p>
        <strong>Previews</strong> allow you to customize the appearance of links, surfacing data that help
        your teammates find relevant information immediately.
      </p>
      <p>Previews can be enriched with data from external services.</p>
      <p>
        By default, previews apply to all URLs found in comments. You can also apply them to message using
        rules.
      </p>
    </Trans>
  ),
};

/*
 * Hook.
 */

export function usePreviewersInfoBox() {
  return useSettingsInfoBox(settingsInfoBoxProps);
}
